import React, { useRef, useState, useEffect } from 'react'
import { Modal, Button, message } from 'antd'
import axios from '../../../utils/AxiosUtil'
import { mask, unmask } from '../../../components/reqAndHint'
import { useSelector } from 'react-redux'
import { relate_cols } from '../../../constants/donateListConstants'
import { areaObj } from '../../../utils/info'
//编辑红冲（发票）关联（的）票据（列表）
export default function EditRelRvsModal(props) {
    let { ermVisible, setErmVisible, reverseBillRecord, setReverseBillRecord, actionRef } = props;
    const [relBillDetails, setRelBillDetails] = useState();//红冲关联的票据
    const cur = useRef({}).current;
    const langValue = useSelector(state => state.langList.value)
    // console.log('reverseBillRecord:', reverseBillRecord);

    //取消关联
    const cancelRelate = async (reverseBillRecord) => {
        // console.log('cancelRelate:', reverseBillRecord);
        // console.log('cur:', cur);
        let { related_bill_code, billDetailTable, relLen } = cur;
        // console.log('{ related_bill_code, billDetailTable, relLen }', { related_bill_code, billDetailTable, relLen })
        mask();
        let { data } = await axios.post('/fund/billmgt/cancelRelate', { related_bill_code, billDetailTable, relLen }, { timeout: 120000 });
        unmask();
        if (data) {
            if (data.ret == 0) {
                message.info(langValue == 0 ? '取消成功Cancel successfully' : (langValue == 1 ? '取消成功' : 'Cancel successfully'));
                setRelBillDetails();
                setErmVisible(false);
                actionRef.current.reload();
                actionRef.current.clearSelected();
            } else {
                let msg = '关联失败';
                let en_msg = 'Association failed'
                if (data.msg) {
                    msg = data.msg;
                }
                if (data.en_msg) {
                    en_msg = data.en_msg;
                }
                Modal.warn({ content: langValue == 0 ? <>{msg}<br />{en_msg}</> : (langValue == 1 ? msg : en_msg) });
            }
        }
    }

    useEffect(() => {
        (async function () {
            let related_bill_code = reverseBillRecord['票据号码'];
            let bill_date = reverseBillRecord['开立日'];
            let yyyyMM = bill_date.substring(0, bill_date.length - 3).replace('-', '');
            let billDetailTable = 'bill_detail_' + yyyyMM;
            cur.related_bill_code = related_bill_code;
            cur.billDetailTable = billDetailTable;
            let { data } = await axios.post('/donation/monthlyList', { billDetailTable, status: 9, related_bill_code, isRef: true });
            if (data && data.data) {
                if (!data.data.length) {
                    Modal.warn({ content: langValue == 0 ? <>关联票据为空<br />The associated ticket is empty</> : (langValue == 1 ? '关联票据为空' : 'The associated ticket is empty') })
                    return;
                }
                var dataarr = data.data
                dataarr.forEach(d => {
                    d.ch_area = '境内';
                    d.en_area = areaObj[d.ch_area]
                    d.en_proj = d['捐款项目']
                })
                //更新关联票据列表
                setRelBillDetails(data.data);
                cur.relLen = data.data.length;
            }

        })()
    }, [])

    return (
        <>
            <Modal
                title={langValue == 0 ? '红冲发票关联信息（编辑、查看）Red invoice associated information (edit, view)' : (langValue == 1 ? '红冲发票关联信息（编辑、查看）' : 'Red invoice associated information (edit, view)')}
                centered
                visible={ermVisible}
                onCancel={() => {
                    setReverseBillRecord();//清除原冲正票暂存
                    setRelBillDetails();//清除关联列表暂存
                    setErmVisible(false);
                }}
                footer={null}
                width={'100%'}
            >
                <>
                    <table className='red_bill_table'>
                        <tbody>
                            <tr><th colSpan={15} className='bill_title'>{langValue == 0 ? '原红冲发票Original red invoice' : (langValue == 1 ? '原红冲发票' : 'Original red invoice')}</th></tr>
                            <>
                                <tr>
                                    {relate_cols.map(item => {
                                        return (
                                            <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                        )
                                    })}
                                </tr>
                                <tr>
                                    <td style={{ color: 'red' }}>{reverseBillRecord ?.['票据号码']}</td>
                                    <td >{reverseBillRecord ?.['开立日'] ?.substring(0, 10)}</td>
                                    <td>{reverseBillRecord ?.['票据名称']}</td>
                                    <td style={{ color: 'red' }}>{reverseBillRecord ?.['票据金额']}</td>
                                    <td>{langValue == 0 ? <>{reverseBillRecord ?.['捐款项目']}<br />{reverseBillRecord ?.en_proj}</> : (langValue == 1 ? reverseBillRecord ?.['捐款项目'] : reverseBillRecord ?.en_proj)}</td>
                                    <td>{reverseBillRecord ?.['地区']}</td>
                                    <td>{reverseBillRecord ?.['志工编号']}</td>
                                    <td>{reverseBillRecord ?.['志工姓名']}</td>
                                    <td>{reverseBillRecord ?.['手机号码']}</td>
                                    <td>{reverseBillRecord ?.['邮箱']}</td>
                                    <td>{reverseBillRecord ?.['作废原因']}</td>
                                </tr>
                            </>
                            <tr style={{ border: 'none', height: '3rem' }}><th colSpan={15} style={{ border: 'none' }}></th></tr>



                            <tr><th colSpan={15} className='bill_title'>{langValue == 0 ? '关联票据列表Associated Bill List' : (langValue == 1 ? '关联票据列表' : 'Associated Bill List')} </th></tr>
                            <tr>
                                <th style={{ width: '3rem' }}>{langValue == 0 ? <>序号<br />Serial number</> : (langValue == 1 ? '序号' : 'Serial number')}</th>
                                {relate_cols.filter(item => item.dataIndex != '作废原因').map(item => {
                                    return (
                                        <th key={item.dataIndex}>{langValue == 0 ? <>{item.ch_title}<br />{item.en_title}</> : (langValue == 1 ? item.ch_title : item.en_title)}</th>
                                    )
                                })}
                            </tr>
                            {
                                relBillDetails && relBillDetails.length
                                    ? relBillDetails.map((d, i) => {
                                        return (
                                            <tr>
                                                <td >{i + 1}</td>
                                                <td >{d ?.['票据号码']}</td>
                                                <td >{d ?.['开立日']}</td>
                                                <td>{d ?.['票据名称']}</td>
                                                <td>{d ?.['票据金额']}</td>
                                                <td>{langValue == 0 ? <>{d ?.['捐款项目']}<br />{d ?.en_proj}</> : (langValue == 1 ? d ?.['捐款项目'] : d ?.en_proj)}</td>
                                                <td>{d ?.['地区']}</td>
                                                <td>{d ?.['志工编号']}</td>
                                                <td>{d ?.['志工姓名']}</td>
                                                <td>{d ?.['手机号码']}</td>
                                                <td>{d ?.['邮箱']}</td>
                                                <td>{langValue == 0 ? <>{d.ch_area}<br />{d.en_area}</> : (langValue == 1 ? d.ch_area : d.en_area)}</td>
                                            </tr>
                                        )
                                    })
                                    : <tr >
                                        <th colSpan={15}>查询中...</th>
                                    </tr>
                            }

                        </tbody>
                    </table>
                    <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '10px' }}>
                        <Button
                            // className='submit_btn'
                            style={{ fontSize: '1.3rem', height: '2.6rem' }}
                            type='primary'
                            onClick={() => cancelRelate(relBillDetails)}
                        >
                            {langValue == 0 ? '取消关联disassociation' : (langValue == 1 ? '取消关联' : 'disassociation')}
                        </Button>
                    </div>
                </>
            </Modal>
        </>
    )
}
